import { Alert as AlertComponent } from './alert';
import { AlertDescription } from './alert.description';
import { AlertTitle } from './alert.title';
import { AlertLevel } from './types';

const Alert = Object.assign(AlertComponent, {
  Title: AlertTitle,
  Description: AlertDescription,
});

export { Alert, AlertLevel };
